function UserIcon({ size = 28 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 28 28">
      <circle
        cx="14"
        cy="14"
        r="13"
        fill="#E8956A"
        stroke="#fff"
        strokeWidth="2"
      />

      <circle
        cx="14"
        cy="11"
        r="4.5"
        fill="none"
        stroke="#fff"
        strokeWidth="1.8"
      />

      <path
        d="M6 24c0-4.4 3.6-8 8-8s8 3.6 8 8"
        fill="none"
        stroke="#fff"
        strokeWidth="1.8"
      />
    </svg>
  );
}

export default UserIcon;